import { useState } from 'react';

import useChatStore from '~/shared/utils/useChatStore';

import { HubSpotMeeting } from '../HubSpotMeeting';

interface HubSpotSchedulingProps {
  schedulingUrl: string;
  actionId: string;
}

export function HubSpotScheduling({ schedulingUrl, actionId }: HubSpotSchedulingProps) {
  const { sendMessage } = useChatStore(({ sendMessage }) => ({ sendMessage }));
  const [isBooked, setIsBooked] = useState(false);

  if (isBooked) {
    return null;
  }

  const handleBookingConfirmed = (payload: unknown) => {
    setIsBooked(true);

    let contentMessage = 'A HubSpot meeting has been successfully scheduled.';

    if (
      payload &&
      typeof payload === 'object' &&
      'meetingsPayload' in payload &&
      payload.meetingsPayload &&
      typeof payload.meetingsPayload === 'object' &&
      'bookingResponse' in payload.meetingsPayload &&
      payload.meetingsPayload.bookingResponse &&
      typeof payload.meetingsPayload.bookingResponse === 'object' &&
      'postResponse' in payload.meetingsPayload.bookingResponse
    ) {
      const bookingResponse = payload.meetingsPayload.bookingResponse.postResponse as {
        timerange?: { start?: number; end?: number };
        organizer?: { name?: string; firstName?: string; lastName?: string };
      };

      const timerange = bookingResponse?.timerange;
      const organizer = bookingResponse?.organizer;

      if (timerange?.start) {
        const meetingDate = new Date(timerange.start);
        const dateStr = meetingDate.toLocaleDateString('en-US', {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        });
        const timeStr = meetingDate.toLocaleTimeString('en-US', {
          hour: 'numeric',
          minute: '2-digit',
          hour12: true,
        });

        const organizerName = organizer?.name || organizer?.firstName || 'the organizer';

        contentMessage = `A HubSpot meeting has been successfully scheduled. {"date": "${dateStr}", "time": "${timeStr}", "organizer": "${organizerName}"}\n${JSON.stringify(payload)}`;
      } else if (organizer?.name || organizer?.firstName) {
        const organizerName = organizer.name || organizer.firstName || 'the organizer';
        contentMessage = `A HubSpot meeting has been successfully scheduled. {"organizer": "${organizerName}"}\n${JSON.stringify(payload)}`;
      } else {
        contentMessage = `A HubSpot meeting has been successfully scheduled.\n${JSON.stringify(payload)}`;
      }
    } else {
      contentMessage = `A HubSpot meeting has been successfully scheduled.\n${JSON.stringify(payload)}`;
    }

    sendMessage({
      actionId,
      content: contentMessage,
      display: undefined,
      isAutoMessage: true,
    });
  };

  return <HubSpotMeeting meetingUrl={schedulingUrl} onMeetingBooked={handleBookingConfirmed} />;
}
